import { Inline } from '@bedrock-layout/primitives';
import styled from 'styled-components';

export const InlineStyled = styled(Inline)`
  @media (max-width: 375px) {
    padding-bottom: 2rem;
  }
`;
